function Home() {
  return (
    <svg
      viewBox="0 0 64 64"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      {/* Roof */}
      <path d="M12 28 L32 12 L52 28" />
      {/* Chimney */}
      <path d="M43 20 V14 H47 V23" />
      {/* Body */}
      <path d="M18 24 V50 H46 V24" />
      {/* Door */}
      <rect x="27" y="36" width="10" height="14" />
    </svg>
  );
}

export default Home;
